import apiClient from "./ApiInterceptor";

export const fetchBranch = async () => {
    const branch_id = localStorage.getItem('branch_id');
    const response = await apiClient.get(`/branches/${branch_id}`);
    if (response.status !== 200) {
        throw new Error("Error fetching branch data");
    }
    return response.data
}

export const fetchBranches = async () => {
    const response = await apiClient.get('/branches');
    if (response.status !== 200) {
        throw new Error("Error fetching branches");
    }
    return response.data
}

export const fetchBranchConfig = async (parameter) => {
    let branch_id = localStorage.getItem('branch_id');
    branch_id = branch_id ? branch_id : 1; // Default to 1 if not found, TODO: handle better accepting the branch_id as param
    const response = await apiClient.get(`/branches/${branch_id}/configs/${parameter}`);
    if (response.status !== 200) {
        throw new Error("Error fetching branch config");
    }
    return response.data
}